import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  AnswerItem,
  AnswersContainers,
  CircleImage,
  CloseQuiz,
  CloseQuizContainer,
  CloseSVG,
  CorrectAnswersWrapper,
  MainContainer,
  OrangeCircle,
  ProgressBarContainer,
  ProgressBarItem,
  ProgressDetails,
  ProgressionSmallFlagBar,
  ProgressionSmallFlagImage,
  QuestionContainer,
  SmallFlagBarContainer,
  TimerIcon,
  TimerIconWrapper,
  TimerWrapper,
  WrongAnswerIcon,
  WrongAnswersWrapper,
} from "./QuizPage.style";
import Text from "../../components/Text";
import FlagIcon from "../../assets/yellow-flag.png";
import CardBg1 from "../../assets/card-1.png";
import CardBg2 from "../../assets/card-2.png";
import CardBg3 from "../../assets/card-3.png";
import CardBg4 from "../../assets/card-4.png";
import TimerImg from "../../assets/timer.png";
import WrongAnswer from "../../assets/wrong-answer.png";
import EmptyAnswer from "../../assets/empty-answer.png";
import { fetchCastleQuestions } from "../../API/castles";
import { saveUserProgress } from "../../API/progress";
import { CastleLossPage } from "./CastleLossPage";
import LoosingProgressModal from "../../components/Modals/LoosingProgressModal";
import BigWhiteX from "../../assets/big-white-x.svg";
import { CastleWinPage } from "./CastleWinPage";
import { GameLoss } from "../../components/GameLoss"; // Import GameLoss modal
import { GameWin } from "../../components/GameWin";
import { fetchUserProgress } from "../../API/progress"; // Import API to fetch progress

const QuizPage = ({ totalPoints, setTotalPoints }) => {
  const location = useLocation(); // Get the data from navigation
  const { castleId, selectedDifficulty } = location.state || {}; // Extract passed data
  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(10);
  const [wrongAnswers, setWrongAnswers] = useState(0);
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [castlePoints, setCastlePoints] = useState(0);
  const [isOpen, setIsOpen] = useState(false); // Progress Loss Modal
  const [pointsPerQuestion, setPointsPerQuestion] = useState(3); // default
  const [showCongrats, setShowCongrats] = useState(false);
  const [showGameLoss, setShowGameLoss] = useState(false);
  const [questionSet, setQuestionSet] = useState("set_1");
  const [castleScore, setCastleScore] = useState(0); // Score for current castle
  const [lives, setLives] = useState(3); // Lives left for current castle
  const [gameLives, setGameLives] = useState(3); // Total castles you can lose
  const [totalScore, setTotalScore] = useState(0); // Overall game score
  const userId = sessionStorage.getItem("user_id");
  const cardBackground = [CardBg1, CardBg2, CardBg3, CardBg4];
  const answerLabels = ["Α", "Β", "Γ", "Δ"];
  const [showWinPage, setShowWinPage] = useState(false);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const shuffleArray = (arr) => [...arr].sort(() => Math.random() - 0.5);
  const navigate = useNavigate();
  const progressOffset = parseInt(sessionStorage.getItem("progress_offset") || "0", 10);
  const progressIndex = currentIndex + progressOffset;
  const audioCount = parseInt(sessionStorage.getItem("castle_audio_count"), 10);
  const progressBarLength = audioCount === 2 ? 6 : questions.length + progressOffset;

  const multiplier = 3; // Hardcoded for now, x3 for all castles
  const flawlessBonus = 50; // Bonus for answering all correctly (0 wrong)

  


  useEffect(() => {
    const storedFails = JSON.parse(
      sessionStorage.getItem("failed_castles") || "[]"
    );
    if (storedFails.length >= 3) {
      setShowGameLoss(true);
    }
  }, []);

  useEffect(() => {
    if (!castleId || !selectedDifficulty) return;
  
    const fetchQuestions = async () => {
      try {
        const currentStep = sessionStorage.getItem("castle_audio_step"); // "1" or "2"
        const currentSet = currentStep === "2" ? "set_2" : "set_1";
        sessionStorage.setItem("current_question_set", currentSet);
        setQuestionSet(currentSet);
  
        console.log(`📦 Fetching questions for Castle ID: ${castleId}, Difficulty: ${selectedDifficulty}, Set: ${currentSet}`);
  
        const response = await fetchCastleQuestions(castleId, selectedDifficulty, currentSet);

if (response && response.questions) {
  const shuffled = response.questions.sort(() => Math.random() - 0.5);

  const audioCount = parseInt(sessionStorage.getItem("castle_audio_count"), 10);
  const isTwoPartCastle = audioCount === 2;

  const sliced = shuffled.slice(0, 3); // ✅ Always slice to 3 questions

  setQuestions(sliced);

  if (currentStep === "2") {
    const storedPoints = parseInt(sessionStorage.getItem("partial_castle_points"), 10) || 0;
    const storedWrong = parseInt(sessionStorage.getItem("partial_wrong_answers"), 10) || 0;
  
    setCastlePoints(storedPoints);
    setWrongAnswers(storedWrong); // ✅ Restore wrong answers
    console.log("🔁 Restored wrong answers from part 1:", storedWrong);
  
    setCurrentIndex(0);
    sessionStorage.setItem("progress_offset", "3");
  } else {
    sessionStorage.setItem("progress_offset", "0");
  }
  
}
 else {
          console.log("⚠️ No questions found for this castle.");
        }
      } catch (error) {
        console.error("❌ Error fetching castle questions:", error);
      }
    };
  
    fetchQuestions();
  }, [castleId, selectedDifficulty]);
  

  
  

  // Start countdown timer
  useEffect(() => {
  if (quizCompleted) return; // 🛑 Don't run timer after quiz is completed

  if (timeLeft === 0) {
    handleNextQuestion();
    return;
  }

  const timer = setTimeout(() => {
    setTimeLeft((prevTime) => prevTime - 1);
  }, 1000);

  return () => clearTimeout(timer);
}, [timeLeft, quizCompleted]); // ← include quizCompleted in dependencies


  // Reset timer when moving to the next question
  useEffect(() => {
    setTimeLeft(10);
  }, [currentIndex]);

  useEffect(() => {
    const audioStep = sessionStorage.getItem("castle_audio_step");
    
    let audioPercent = 0;
  
    if (audioStep === "2") {
      audioPercent = parseFloat(sessionStorage.getItem("audio_2_listened_percent")) || 0;
    } else {
      audioPercent = parseFloat(sessionStorage.getItem("audio_listened_percent")) || 0;
    }
  
    let points = 0;
  
    if (audioPercent < 33) {
      points = selectedDifficulty === "easy" ? 3 : 6;
    } else if (audioPercent < 66) {
      points = selectedDifficulty === "easy" ? 2 : 4;
    } else {
      points = selectedDifficulty === "easy" ? 1 : 2;
    }
  
    console.log("🔊 Audio step:", audioStep);
    console.log("🔊 Audio listened percent:", audioPercent);
    console.log("⭐️ Points per question (after audio reduction):", points);
  
    setPointsPerQuestion(points);
  }, [selectedDifficulty]);
  

  useEffect(() => {
    if (!userId) return;
    const storedPoints = parseInt(
      sessionStorage.getItem(`points_${userId}`),
      10
    );
    if (!isNaN(storedPoints)) setTimeout(() => setTotalPoints(storedPoints), 0);
  }, [userId]);

  
  

  const updateTotalPoints = (userId, newPoints) => {
    const isGuest = sessionStorage.getItem("is_guest") === "true";
  
    if (isGuest) {
      let storedPoints = parseInt(sessionStorage.getItem("points_guest") || "0", 10);
      const updatedPoints = Math.max(0, storedPoints + newPoints); // ⛔️ No negatives
      sessionStorage.setItem("points_guest", updatedPoints.toString());

  
      console.log(`👤 Guest User points updated:`);
      console.log(`   🔹 Previous: ${storedPoints}`);
      console.log(`   🔹 Delta: ${newPoints > 0 ? "+" : ""}${newPoints}`);
      console.log(`   🔹 New Total: ${updatedPoints}`);
    } else {
      let storedPoints = sessionStorage.getItem(`points_${userId}`);
      storedPoints = storedPoints ? parseInt(storedPoints, 10) : 0;
      const updatedPoints = storedPoints + newPoints;
      sessionStorage.setItem(`points_${userId}`, updatedPoints.toString());
  
      console.log(`👤 User [ID: ${userId}] points updated:`);
      console.log(`   🔹 Previous: ${storedPoints}`);
      console.log(`   🔹 Delta: ${newPoints > 0 ? "+" : ""}${newPoints}`);
      console.log(`   🔹 New Total: ${updatedPoints}`);
    }
  };
  
  

  const handleNextQuestion = async (option) => {
    const halfwayIndex = 2;
    const currentQuestion = questions[currentIndex];
    if (!currentQuestion) return;
  
    const isCorrect = currentQuestion.correct_option === option;
    const delta = isCorrect ? pointsPerQuestion : 0;
    const updatedCastlePoints = castlePoints + delta;
  
    let updatedWrongAnswers = wrongAnswers;
    if (!isCorrect) {
      updatedWrongAnswers += 1;
      setWrongAnswers(updatedWrongAnswers);
  
      if (updatedWrongAnswers === 3) {
        // ⚠️ Immediately fail the castle before going to part 2
        const failedCastles = JSON.parse(sessionStorage.getItem("failed_castles") || "[]");
        if (!failedCastles.includes(castleId)) {
          failedCastles.push(castleId);
          sessionStorage.setItem("failed_castles", JSON.stringify(failedCastles));
        }
  
        // Cleanup before triggering loss screen
        sessionStorage.removeItem("castle_audio_step");
        sessionStorage.removeItem("partial_castle_points");
        sessionStorage.removeItem("partial_wrong_answers");
  
        console.log(`💥 Castle ${castleId} marked as FAILED — won't continue to part 2.`);
        return; // ⚠️ Stop here so CastleLossPage renders automatically
      }
    } else {
      setCorrectAnswers((prev) => prev + 1);
    }
  
    console.log(`\n📘 Answering Question ${currentIndex + 1}`);
    console.log(`   ➤ Question: ${currentQuestion.question}`);
    console.log(`   ➤ Selected Option: ${option}`);
    console.log(`   ➤ Correct Option: ${currentQuestion.correct_option}`);
    console.log(`   ➤ Answer is ${isCorrect ? "✅ CORRECT" : "❌ WRONG"}`);
    console.log(`   ➤ Points Per Question: ${pointsPerQuestion}`);
    console.log(`   ➤ Delta: ${delta}`);
    console.log(`   ➤ Castle Points AFTER: ${updatedCastlePoints}`);
    console.log(`   ➤ Total wrong answers so far: ${updatedWrongAnswers}`);
  
    setCastlePoints(updatedCastlePoints);
  
    const audioCount = parseInt(sessionStorage.getItem("castle_audio_count"), 10);
    const currentSet = sessionStorage.getItem("current_question_set");
  
    if (audioCount === 2 && currentSet === "set_1" && currentIndex === halfwayIndex) {
      sessionStorage.setItem("castle_audio_step", "2");
      sessionStorage.setItem("current_question_set", "set_2");
      sessionStorage.setItem("partial_castle_points", updatedCastlePoints);
      sessionStorage.setItem("partial_wrong_answers", updatedWrongAnswers.toString());
  
      navigate("/castle-details-part-2", {
        state: { castleId, selectedDifficulty },
      });
      return;
    }
  
    const isLast = currentIndex === questions.length - 1;
    if (!isLast) {
      setCurrentIndex((prev) => prev + 1);
      return;
    }
  
    // 🎯 Final question logic
    setQuizCompleted(true);
    console.log("🎉 Finished the last question!");
  
    const totalWrong = isCorrect ? wrongAnswers : wrongAnswers + 1;
    const flawless = totalWrong === 0;
  
    let finalCastleScore = updatedCastlePoints;
    const multiplier = audioCount === 2 ? 3 : 2;
  
    if (flawless) {
      finalCastleScore += flawlessBonus;
      sessionStorage.setItem("flawless_bonus_applied", "true");
      console.log(`🏆 Flawless Victory! +${flawlessBonus} points`);
    } else {
      sessionStorage.removeItem("flawless_bonus_applied");
    }
  
    finalCastleScore *= multiplier;
    console.log(`🎯 Multiplier: x${multiplier}`);
    console.log(`🏁 Final Castle Score: ${finalCastleScore}`);
  
    sessionStorage.setItem("last_castle_score", finalCastleScore.toString());
  
    const isGuest = sessionStorage.getItem("is_guest") === "true";
    const conqueredCastles = JSON.parse(sessionStorage.getItem("conquered_castles") || "[]");
    const conqueredColors = JSON.parse(sessionStorage.getItem("conquered_castle_colors") || "{}");
    const color = sessionStorage.getItem("color");
  
    if (totalWrong < 3) {
      if (!conqueredCastles.includes(castleId)) {
        conqueredCastles.push(castleId);
        conqueredColors[castleId] = color;
        sessionStorage.setItem("conquered_castles", JSON.stringify(conqueredCastles));
        sessionStorage.setItem("conquered_castle_colors", JSON.stringify(conqueredColors));
        console.log(`🎉 Castle ${castleId} conquered with color ${color}`);
      }
  
      const gameplayCount = parseInt(sessionStorage.getItem("gameplay_number") || "1", 10);
      if (gameplayCount > 1) {
        const newlyConquered = JSON.parse(sessionStorage.getItem("newly_conquered_castles") || "[]");
        if (!newlyConquered.includes(castleId)) {
          newlyConquered.push(castleId);
          sessionStorage.setItem("newly_conquered_castles", JSON.stringify(newlyConquered));
          console.log("🆕 Newly conquered castles this session:", newlyConquered);
        }
      }
  
      if (isGuest) {
        const prev = parseInt(sessionStorage.getItem("points_guest") || "0", 10);
        const updated = prev + finalCastleScore;
        sessionStorage.setItem("points_guest", updated.toString());
        console.log(`👤 Guest Score updated: ${prev} → ${updated}`);
      } else {
        const prev = parseInt(sessionStorage.getItem(`points_${userId}`) || "0", 10);
        const updated = prev + finalCastleScore;
        sessionStorage.setItem(`points_${userId}`, updated.toString());
  
        saveUserProgress(userId, conqueredCastles, updated, castleId).then((res) => {
          if (res.success) console.log("✅ Progress saved!");
          else console.error("❌ Progress save failed:", res.message);
        });
      }
    } else {
      const failedCastles = JSON.parse(sessionStorage.getItem("failed_castles") || "[]");
      if (!failedCastles.includes(castleId)) {
        failedCastles.push(castleId);
        sessionStorage.setItem("failed_castles", JSON.stringify(failedCastles));
        console.log(`💥 Castle ${castleId} marked as FAILED.`);
      }
  
      if (failedCastles.length >= 3) {
        setShowGameLoss(true);
      }
    }
  
    // 🧹 Cleanup
    sessionStorage.removeItem("castle_audio_step");
    sessionStorage.removeItem("partial_castle_points");
    sessionStorage.removeItem("partial_wrong_answers");
  };
  
  
  
  const shouldShowGameWin = () => {
    const allowReplay = sessionStorage.getItem("allow_replay_conquered") === "true";
    const totalConquered = JSON.parse(sessionStorage.getItem("conquered_castles") || "[]");
    const newlyConquered = JSON.parse(sessionStorage.getItem("newly_conquered_castles") || "[]");
  
    console.log("🎯 Gameplay:", sessionStorage.getItem("gameplay_number"));
    console.log("🆕 Newly Conquered Castles:", newlyConquered);
    console.log("🏰 Total Conquered:", totalConquered);
  
    return allowReplay
      ? newlyConquered.length >= 9
      : totalConquered.length >= 9;
  };
  
  
  
  
  if (!questions) return null;

  return (
    <MainContainer>
  {quizCompleted && shouldShowGameWin() && <GameWin />}




  <CloseQuizContainer>
    <CloseQuiz
      onClick={() => {
        setIsOpen(!isOpen);
      }}
    >
      <CloseSVG src={BigWhiteX} />
    </CloseQuiz>
  </CloseQuizContainer>

  <LoosingProgressModal
    open={isOpen}
    onClose={() => setIsOpen(false)}
    castleId={castleId}
  />

  <ProgressDetails>
    <WrongAnswersWrapper>
      {Array.from({ length: 3 }, (_, index) => (
        <WrongAnswerIcon
          key={index}
          src={index < wrongAnswers ? WrongAnswer : EmptyAnswer}
        />
      ))}
    </WrongAnswersWrapper>

    <TimerWrapper>
      <TimerIconWrapper>
        <TimerIcon src={TimerImg} />
      </TimerIconWrapper>
      <Text
        fontFamily="Manrope"
        fontSize="14px"
        fontWeight="700"
        lineheight="100%"
        color="#FFFBEC"
      >
        {timeLeft}”
      </Text>
    </TimerWrapper>

    <ProgressBarContainer>
  {Array.from({ length: progressBarLength }, (_, index) => (
    <ProgressBarItem
      key={index}
      $index={index}
      bgcolor={index < progressIndex ? "#3E626A" : "#F3DE8A"}
      $activeIndex={progressIndex}
    />
  ))}


{sessionStorage.getItem("castle_audio_count") === "2" && (
  <SmallFlagBarContainer>
    <ProgressionSmallFlagBar
      bordercolor={progressIndex >= 3 ? "#3E626A" : "#F3DE8A"}
    >
      <ProgressionSmallFlagImage
        src={FlagIcon}
        filter={progressIndex >= 3}
      />
    </ProgressionSmallFlagBar>
  </SmallFlagBarContainer>
)}

</ProgressBarContainer>


    <CorrectAnswersWrapper>
      <Text
        fontFamily="Manrope"
        fontSize="14px"
        fontWeight="700"
        lineheight="100%"
        color="#FFFBEC"
      >
        {castlePoints}
      </Text>
    </CorrectAnswersWrapper>
  </ProgressDetails>

  {/* ✅ Show question and answers only if quiz not completed */}
{questions.length > 0 && !quizCompleted && (
  <>
    <QuestionContainer>
      <Text
        fontFamily="'Source Serif 4'"
        fontSize="16px"
        fontWeight="400"
        lineheight="100%"
        color="#FFFBEC"
      >
        Ερώτηση {currentIndex + 1}
      </Text>
      <OrangeCircle>
        <Text
          fontFamily="'Source Serif 4'"
          fontSize="16px"
          fontWeight="900"
          lineheight="26px"
          color="#FFFBEC"
        >
          <span className="questionPoints">{pointsPerQuestion}</span>
        </Text>
      </OrangeCircle>
      <Text
        fontFamily="'Source Serif 4'"
        fontSize="16px"
        fontWeight="400"
        lineheight="100%"
        color="#FFFBEC"
      >
        πόντοι
      </Text>
      <Text
        fontFamily="'Source Serif 4'"
        fontSize="25px"
        fontWeight="700"
        lineheight="100%"
        color="#FFFBEC"
        margin="10px 0 0 0"
      >
        {questions[currentIndex].question}
      </Text>
    </QuestionContainer>

    <AnswersContainers>
      {questions[currentIndex]?.options?.map((option, index) => (
        <AnswerItem
          key={index}
          bg={cardBackground[index]}
          onClick={() => handleNextQuestion(index)}
        >
          <CircleImage>
            <Text
              fontFamily="'Source Serif 4'"
              fontWeight="700"
              fontSize="40px"
              lineheight="100%"
              color="#fffbec"
            >
              {answerLabels[index]}
            </Text>
          </CircleImage>
          <Text
            fontFamily="Manrope"
            fontWeight="600"
            fontSize="15px"
            lineheight="20.5px"
            color="#72969b"
          >
            {option}
          </Text>
        </AnswerItem>
      ))}
    </AnswersContainers>
  </>
)}


  {/* ✅ Show win screen only after quiz is finished */}
  {quizCompleted && <CastleWinPage points={castlePoints} />}

  {/* ✅ Show loss modal if 3 wrong answers */}
  {wrongAnswers === 3 && <CastleLossPage />}
</MainContainer>

  );
};

export default QuizPage;
